// src/components/FullPageLoader.tsx
import React from 'react';
import '../assets/css/loader.css'; // Adjust the path as necessary
import loaderGif from 'src/assets/images/loader-gif.gif'

const SplashScreen: React.FC = () => {
    return (
        <div className="full_page">
            <div className="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            
             {/* <img src={loaderGif} alt="" /> */}
        </div>
    );
};

export default SplashScreen;
